/**
 * /me/salary — Me → Pay → Salary: the employee's own current salary
 * breakup and yearly CTC (GET /api/v1/payroll/me/salary, self only).
 *
 * Its own tab (nav-build spec: Pay = Payslips · Salary · Tax · Loans), so
 * the Payslips tab opens on the slips instead of under this table.
 */

import { createFileRoute } from "@tanstack/react-router";
import { MeModuleShell } from "@/components/shared/me-module-shell";
import { MySalaryCard } from "@/components/payroll/my-salary-card";

export const Route = createFileRoute("/_authgated/app/$tenantSlug/me/salary")({
  component: MySalaryRoute,
});

function MySalaryRoute() {
  return (
    <MeModuleShell title="Salary" description="Your current salary breakup and yearly CTC.">
      <MySalaryCard />
    </MeModuleShell>
  );
}
